/**
 * Проверка, домена на локальный хост
 * @param host - домен подключения
 */
const checkIsLocalhost = (host: string): boolean => {
  const hostDomainLevels = getDomainLevels(host)
  const hostTopLevelDomain = hostDomainLevels[hostDomainLevels.length - 1]

  const isLocalhost = hostTopLevelDomain.match('localhost')

  return !!isLocalhost
}

/**
 * Разбиваем домент на подстроки
 * @param domain - домен приложения
 */
const getDomainLevels = (domain: string): string[] =>
  !domain ? [] : domain.split('.')

/**
 * Функция возвращает домен сайта города заменяя у host поддомен города и домен врехнего уровня на значения из cityDomain
 * это сделано для поддержки корректных ссылок на другие гроода для доменов разных уровней и localhost-a
 * @param host - домен подключения
 * @param cityDomain - домен города приложения
 */
export const getCityDomainForHost = (
  host: string,
  cityDomain: string,
): string => {
  const cityDomainLevels = getDomainLevels(cityDomain)
  const citySubdomain = cityDomainLevels[0]
  const cityTopLevelDomain = cityDomainLevels[cityDomainLevels.length - 1]
  const citySecondLevelDomain = cityDomainLevels[cityDomainLevels.length - 2]

  const hostDomainLevels = getDomainLevels(host)

  // меняем поддомен хоста на поддомен городского домена
  hostDomainLevels[0] = citySubdomain

  // Если хостом является localhost то меняем только поддомен т.к. localhost это и есть домен верхнего уровня
  if (checkIsLocalhost(host)) return hostDomainLevels.join('.')

  // меняем у хоста домен второго уровня на домен второго уровня городского домена
  hostDomainLevels[hostDomainLevels.length - 2] = citySecondLevelDomain

  // меняем у хоста национальный домен на национальный домен городского домена
  hostDomainLevels[hostDomainLevels.length - 1] = cityTopLevelDomain

  return hostDomainLevels.join('.')
}
